"use strict";
const _ = require('lodash');
const organization = require('../organization');
const isFlaivyCredential = entity => _.includes(organization.FLAIVY_ORGANIZATION_IDS, entity.owningSupplierOrganizationId);
module.exports = {
    isFlaivyCredential,
};
